import React, { Fragment, useEffect, useState } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import Navigation from '../lp2/Navigation';
import api from '../api';
import { Button } from '../lp2/ui/button.tsx';
import { CheckCircle, Clock, CreditCard, MessageCircle } from 'lucide-react';

/**
 * Bestaetigung nach der Registrierung. Ersetzt den frueheren Zwangswechsel
 * auf /payment: wer einrichtet, soll zuerst die Gewissheit bekommen, dass es
 * laeuft – die Zahlungsdaten sind ein Angebot, keine Huerde.
 */
const Willkommen = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [daten, setDaten] = useState(state || null);

  useEffect(() => {
    // Beim direkten Aufruf oder nach einem Neuladen fehlt der State.
    if (daten?.checkInName !== undefined) return;
    api.get('/profile')
      .then((r) => setDaten({
        checkInName: r.data.checkInName,
        name: r.data.name,
        trialEndsAt: r.data.trialEndsAt,
      }))
      .catch(() => navigate('/login'));
  }, [daten, navigate]);

  const person = daten?.checkInName;
  const bisWann = daten?.trialEndsAt
    ? new Date(daten.trialEndsAt).toLocaleDateString('de-CH',
        { day: '2-digit', month: 'long', year: 'numeric' })
    : null;

  return (
    <Fragment>
      <Navigation />
      <section className="min-h-screen bg-gradient-to-b from-blue-50 to-white py-16 px-4">
        <div className="max-w-2xl mx-auto">
          <div className="text-center mb-8">
            <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100 mb-5">
              <CheckCircle className="h-9 w-9 text-green-600" />
            </div>
            <h1 className="text-3xl font-bold text-gray-900 mb-3">Eingerichtet.</h1>
            <p className="text-lg text-gray-700">
              {person
                ? <>{person} bekommt morgen um 8 Uhr die erste Nachricht.</>
                : <>Sie bekommen morgen um 8 Uhr die erste Nachricht.</>}
            </p>
            <p className="text-lg text-gray-700 mt-1">
              Die ersten 14 Tage sind kostenlos{bisWann ? <> – bis zum {bisWann}</> : null}.
            </p>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-8 space-y-6">
            {person && (
              <div className="flex items-start gap-4">
                <div className="bg-blue-100 p-2 rounded-full mt-0.5">
                  <MessageCircle className="w-5 h-5 text-blue-600" />
                </div>
                <div>
                  <h2 className="font-semibold text-gray-900 mb-1">
                    {person} weiss Bescheid
                  </h2>
                  <p className="text-gray-600 text-sm">
                    Wir haben eine kurze Nachricht geschickt, in der steht, wer
                    den Dienst eingerichtet hat und worum es geht.
                  </p>
                </div>
              </div>
            )}

            <div className="flex items-start gap-4">
              <div className="bg-blue-100 p-2 rounded-full mt-0.5">
                <Clock className="w-5 h-5 text-blue-600" />
              </div>
              <div>
                <h2 className="font-semibold text-gray-900 mb-1">Ab morgen früh</h2>
                <p className="text-gray-600 text-sm">
                  Jeden Morgen um 8 Uhr geht die Nachricht raus. Kommt bis 12 Uhr
                  keine Antwort, melden wir uns bei Ihnen. Sonst hören Sie nichts
                  von uns — und das ist das gute Zeichen.
                </p>
              </div>
            </div>

            <div className="border-t pt-6">
              <div className="flex items-start gap-4 mb-4">
                <div className="bg-gray-100 p-2 rounded-full mt-0.5">
                  <CreditCard className="w-5 h-5 text-gray-600" />
                </div>
                <div>
                  <h2 className="font-semibold text-gray-900 mb-1">
                    Zahlungsdaten — später oder jetzt
                  </h2>
                  <p className="text-gray-600 text-sm">
                    Sie brauchen jetzt nichts zu hinterlegen. Wir erinnern Sie
                    rechtzeitig vor Ablauf der Testphase.
                  </p>
                </div>
              </div>
              <div className="flex flex-col sm:flex-row gap-3">
                <Link to="/profile" className="flex-1">
                  <Button className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg">
                    Zu meinem Profil
                  </Button>
                </Link>
                <Link to="/payment" className="flex-1">
                  <Button variant="outline" className="w-full py-3 rounded-lg border-gray-300">
                    Zahlungsdaten jetzt hinterlegen
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default Willkommen;
